import React, { useEffect } from "react";
import img from "./../../assets/provider-23.jpg";
import { CircleCheck } from "lucide-react";

const AboutUs = () => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <div className="flex flex-col lg:flex-row items-center gap-8 xl:gap-16">
        {/* Image Section */}
        <div className="w-full lg:w-1/2">
          <div className="relative rounded-lg overflow-hidden shadow-xl">
            <img
              src={img}
              alt="Our Team"
              className="w-full h-auto object-cover aspect-[4/3] lg:aspect-[3/4] xl:aspect-[4/3]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          </div>
        </div>

        {/* Content Section */}
        <div className="w-full lg:w-1/2">
          <div className="space-y-6">
            <span className="inline-block text-sm font-semibold text-primary tracking-wider uppercase">
              ABOUT OUR COMPANY
            </span>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
              Best Solution For Cleaning Services
            </h1>

            <div className="space-y-4 text-gray-600">
              <p className="text-base md:text-lg">
                Welcome to Wave Tech Service, your premier destination for connecting with
                top-rated service providers and finding the perfect match for your
                needs. Our platform is designed to simplify the process of
                discovering, evaluating, and hiring trusted professionals across a
                wide range of services.
              </p>
              
              <p className="text-base md:text-lg">
                At Wave, our mission is to bridge the gap between service
                providers and customers by offering a seamless and efficient
                marketplace experience. We aim to empower both parties by providing a
                reliable platform where quality, transparency, and customer
                satisfaction are our top priorities.
              </p>
            </div>

            {/* Features List */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CircleCheck className="flex-shrink-0 mt-0.5 text-green-500" />
                  <p className="text-gray-600">
                    We prioritize quality and reliability
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
// import React, { useEffect } from "react";
// import { CircleCheck, Users, Award, ShieldCheck, HeartHandshake } from "lucide-react";
// import img from "./../../assets/provider-23.jpg";
// // import teamImg from "./../../assets/team.jpg"; // Add a team image
// // import statsImg from "./../../assets/stats.jpg"; // Add a stats/achievement image

// const AboutUs = () => {
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth"
//     });
//   }, []);
  
//   const features = [
//     "Quality and reliability guaranteed",
//     "Verified service providers",
//     "Transparent pricing",
//     "24/7 customer support",
//     "Satisfaction guarantee",
//     "Eco-friendly cleaning products"
//   ];

//   const stats = [
//     { value: "500+", label: "Happy Clients" },
//     { value: "100+", label: "Professional Staff" },
//     { value: "10+", label: "Years Experience" },
//     { value: "99%", label: "Satisfaction Rate" }
//   ];

//   return (
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20 space-y-20">
//       {/* Hero Section */}
//       <div className="flex flex-col lg:flex-row items-center gap-8 xl:gap-16">
//         {/* Image Section */}
//         <div className="w-full lg:w-1/2">
//           <div className="relative rounded-xl overflow-hidden shadow-2xl">
//             <img
//               src={img}
//               alt="Our Team at Work"
//               className="w-full h-auto object-cover aspect-[4/3] lg:aspect-[3/4] xl:aspect-[4/3] transform hover:scale-105 transition duration-500"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
//             <div className="absolute bottom-6 left-6 right-6 text-white">
//               <h3 className="text-xl font-bold">Trusted Since 2012</h3>
//               <p className="text-sm opacity-90">Over a decade of excellence in service</p>
//             </div>
//           </div>
//         </div>

//         {/* Content Section */}
//         <div className="w-full lg:w-1/2">
//           <div className="space-y-6">
//             <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-semibold tracking-wider uppercase">
//               About Our Company
//             </span>
            
//             <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900">
//               Your Trusted Partner for <span className="text-primary">Premium Cleaning</span> Services
//             </h1>

//             <div className="space-y-4 text-gray-600">
//               <p className="text-base md:text-lg">
//                 At Truelysell, we're revolutionizing the way you find and hire cleaning professionals. Founded in 2012, our mission has always been to deliver exceptional cleaning services while creating meaningful connections between customers and trusted providers.
//               </p>
              
//               <p className="text-base md:text-lg">
//                 What sets us apart is our commitment to quality, reliability, and customer satisfaction. Every provider on our platform undergoes rigorous vetting, so you can rest assured you're getting the best service possible.
//               </p>
//             </div>

//             {/* Features List */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
//               {features.map((feature, index) => (
//                 <div key={index} className="flex items-start gap-3">
//                   <CircleCheck className="flex-shrink-0 mt-0.5 text-primary" size={20} />
//                   <p className="text-gray-600 font-medium">{feature}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Our Story Section */}
//       <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
//         <div className="max-w-4xl mx-auto text-center">
//           <h2 className="text-2xl md:text-3xl font-bold mb-6">Our Story</h2>
//           <div className="space-y-6 text-gray-600">
//             <p>
//               Truelysell began with a simple idea: to make finding reliable cleaning services as easy as a few clicks. Our founder, Jane Doe, struggled to find trustworthy cleaners for her busy family and recognized the need for a better solution.
//             </p>
//             <p>
//               Starting with just three local cleaners in 2012, we've grown into a nationwide network of thousands of professionals. But our core values remain the same - integrity, excellence, and putting customers first.
//             </p>
//             <p>
//               Today, we're proud to serve over 50,000 happy customers annually, with a satisfaction rate that consistently exceeds industry standards.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Stats Section */}
//       <div className="relative rounded-2xl overflow-hidden">
//         {/* <img src={statsImg} alt="Our Achievements" className="w-full h-96 object-cover" /> */}
//         <div className="absolute inset-0 bg-black/50"></div>
//         <div className="absolute inset-0 flex items-center">
//           <div className="max-w-7xl mx-auto w-full px-6">
//             <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
//               {stats.map((stat, index) => (
//                 <div key={index} className="text-center text-white">
//                   <p className="text-3xl sm:text-4xl font-bold mb-2">{stat.value}</p>
//                   <p className="text-sm sm:text-base opacity-90">{stat.label}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Team Section */}
//       <div className="flex flex-col lg:flex-row items-center gap-8 xl:gap-16">
//         {/* Content Section */}
//         <div className="w-full lg:w-1/2 order-2 lg:order-1">
//           <div className="space-y-6">
//             <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Meet Our <span className="text-primary">Dedicated</span> Team</h2>
            
//             <div className="space-y-4 text-gray-600">
//               <p>
//                 Behind Truelysell is a passionate team of professionals committed to delivering exceptional service. From our customer support specialists to our quality assurance team, every member plays a vital role in our success.
//               </p>
              
//               <p>
//                 We invest heavily in training and development to ensure our team stays at the forefront of the cleaning industry. Our providers aren't just employees - they're cleaning experts who take pride in their work.
//               </p>
//             </div>

//             <div className="flex flex-wrap gap-4 pt-2">
//               <div className="flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full">
//                 <Users className="text-primary" size={18} />
//                 <span className="text-sm font-medium">Certified Professionals</span>
//               </div>
//               <div className="flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full">
//                 <Award className="text-primary" size={18} />
//                 <span className="text-sm font-medium">Award-Winning Service</span>
//               </div>
//               <div className="flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full">
//                 <ShieldCheck className="text-primary" size={18} />
//                 <span className="text-sm font-medium">Fully Insured</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Image Section */}
//         <div className="w-full lg:w-1/2 order-1 lg:order-2">
//           <div className="relative rounded-xl overflow-hidden shadow-2xl">
//             {/* <img
//               src={teamImg}
//               alt="Our Team"
//               className="w-full h-auto object-cover aspect-[4/3]"
//             /> */}
//             <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
//           </div>
//         </div>
//       </div>

//       {/* Values Section */}
//       <div className="space-y-12">
//         <div className="text-center max-w-3xl mx-auto">
//           <h2 className="text-2xl md:text-3xl font-bold mb-4">Our Core Values</h2>
//           <p className="text-gray-600">
//             These principles guide everything we do at Truelysell and shape our company culture
//           </p>
//         </div>

//         <div className="grid md:grid-cols-3 gap-8">
//           <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
//             <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
//               <HeartHandshake className="text-primary" size={24} />
//             </div>
//             <h3 className="text-xl font-semibold mb-3">Customer First</h3>
//             <p className="text-gray-600">
//               We listen to our customers and go above and beyond to exceed their expectations. Your satisfaction is our top priority.
//             </p>
//           </div>

//           <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
//             <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
//               <ShieldCheck className="text-primary" size={24} />
//             </div>
//             <h3 className="text-xl font-semibold mb-3">Integrity</h3>
//             <p className="text-gray-600">
//               We believe in transparency and honesty in all our dealings. What we promise is what we deliver.
//             </p>
//           </div>

//           <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
//             <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
//               <Award className="text-primary" size={24} />
//             </div>
//             <h3 className="text-xl font-semibold mb-3">Excellence</h3>
//             <p className="text-gray-600">
//               We strive for perfection in every service we provide, continuously improving our standards.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* CTA Section */}
//       <div className="bg-primary rounded-2xl p-8 md:p-12 text-center text-white">
//         <h2 className="text-2xl md:text-3xl font-bold mb-4">Ready to Experience the Truelysell Difference?</h2>
//         <p className="max-w-2xl mx-auto mb-6 opacity-90">
//           Join thousands of satisfied customers who trust us for their cleaning needs
//         </p>
//         <div className="flex flex-col sm:flex-row justify-center gap-4">
//           <button className="px-6 py-3 bg-white text-primary font-medium rounded-lg hover:bg-gray-100 transition">
//             Book a Service Now
//           </button>
//           <button className="px-6 py-3 border border-white text-white font-medium rounded-lg hover:bg-white/10 transition">
//             Contact Our Team
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;